import React from 'react';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../hooks/useLanguage';
import { register as registerApi } from '../services/authApi';

const Register = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { getLocalizedPath } = useLanguage();
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const onSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setError('');
    setLoading(true);
    try {
      await registerApi({
        firstName,
        lastName,
        email,
        password,
        role: 'customer',
      });
      navigate(getLocalizedPath('/account'));
    } catch (err) {
      setError(err?.message || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mt-[78px]">
      <div className="max-w-[1280px] mx-auto pt-8 sm:pt-[92px] pb-[166px] sm:pb-[100px] break-words whitespace-normal">
        <div className="px-5 text-center">
          <h2 className="text-black text-[32px] leading-[40px] sm:text-[40px] sm:leading-[50px] tracking-[-1.25px] font-normal uppercase libre-baskerville mb-4 sm:mb-5">
            {t('auth.register.title')}
          </h2>
          <p className="text-[#727272] text-[16px] leading-[20px] tracking-[-1px] font-normal">
            {t('auth.register.subtitle')}
          </p>
        </div>
        <form
          onSubmit={onSubmit}
          className="mt-10 max-w-[600px] mx-auto bg-[#F6F6F6] px-5 sm:px-[50px] py-6 sm:py-[33px] space-y-6"
        >
          <div className="w-full space-y-3">
            <label className="text-[#000000] text-[14px] font-normal leading-[15px] uppercase">
              {t('auth.register.firstNameLabel')}
            </label>
            <input
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              type="text"
              placeholder={t('auth.register.firstNamePlaceholder')}
              className="bg-[#0000001A] w-full px-6 py-3.5 text-[12px] leading-[19px] tracking-[-0.64px] outline-none placeholder:text-[#808080] placeholder:tracking-[-0.64px]"
            />
          </div>
          <div className="w-full space-y-3">
            <label className="text-[#000000] text-[14px] font-normal leading-[15px] uppercase">
              {t('auth.register.lastNameLabel')}
            </label>
            <input
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              type="text"
              placeholder={t('auth.register.lastNamePlaceholder')}
              className="bg-[#0000001A] w-full px-6 py-3.5 text-[12px] leading-[19px] tracking-[-0.64px] outline-none placeholder:text-[#808080] placeholder:tracking-[-0.64px]"
            />
          </div>
          <div className="w-full space-y-3">
            <label className="text-[#000000] text-[14px] font-normal leading-[15px] uppercase">
              {t('auth.register.emailLabel')}
            </label>
            <input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              placeholder={t('auth.register.emailPlaceholder')}
              className="bg-[#0000001A] w-full px-6 py-3.5 text-[12px] leading-[19px] tracking-[-0.64px] outline-none placeholder:text-[#808080] placeholder:tracking-[-0.64px]"
            />
          </div>
          <div className="w-full space-y-3">
            <label className="text-[#000000] text-[14px] font-normal leading-[15px] uppercase">
              {t('auth.register.passwordLabel')}
            </label>
            <input
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type="password"
              placeholder={t('auth.register.passwordPlaceholder')}
              className="bg-[#0000001A] w-full px-6 py-3.5 text-[12px] leading-[19px] tracking-[-0.64px] outline-none placeholder:text-[#808080] placeholder:tracking-[-0.64px]"
            />
          </div>
          {error ? (
            <div className="text-red-600 text-center text-sm">{error}</div>
          ) : null}
          <button
            disabled={loading}
            type="submit"
            className="bg-[#000000] w-full py-5 text-white text-[13px] leading-[14px] uppercase font-medium"
          >
            {loading
              ? t('auth.register.submitting') || '...'
              : t('auth.register.submit')}
          </button>
          <p className="text-[16px] leading-[20px] text-[#727272] font-normal tracking-[-1.25px] text-center">
            {t('auth.register.haveAccount')}{' '}
            <a href="/login" className="text-black underline leading-[20px]">
              {t('auth.register.loginLink')}
            </a>
          </p>
        </form>
      </div>
    </div>
  );
};

export default Register;
